import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import {
  StatusContainer,
  CollapsibleContainer,
  LabeledValue,
  LabelText
} from '@/features/Application/elements'
import StatusComponent from './status-component'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 24px;
`

const Mobile = ({ data = {}, isLocked, isLoading }) => {
  const { t } = useTranslation()
  const showStatus = true
  const { details = [], rate } = data

  const status = {
    poor: t('l.application.view.poor.label', 'Poor'),
    average: t('l.application.view.average.label', 'Average'),
    very_good: t('l.application.view.very_good.label', 'Very Good'),
    excellent: t('l.application.view.excellent.label', 'Excellent'),
    analyzing: t('l.application.view.analyzing.label', 'Analyzing')
  }

  const statusText = status[rate]
  const title = t('l.application.view.identity_verification.label', 'Identity Verification')
  const LABELS = {
    drivers_license: t('b.profile.edit.drivers_license.text', "Driver's Licence"),
    passport: t('b.profile.edit.passport.text', 'Passport'),
    health_insurance: t('b.profile.edit.health_insurance_card.text', 'Health Insurance Card'),
    permanent_resident: t('b.profile.edit.residence_card.text', 'Permanent Residence Card'),
    'Facial Verification': t('b.profile.edit.facial_verification.text', 'Facial Verification')
  }

  return (
    <Wrapper>
      <StatusContainer
        title={title}
        showStatus={showStatus}
        statusType={rate}
        statusTitle={statusText}
        isLocked={isLocked}
        isLoading={isLoading}
      >
        {details?.map((detail, index) => {
          const typeText = LABELS[detail?.type] ?? '-'

          return (
            <CollapsibleContainer
              title={typeText}
              smallBorder
              showToggle={false}
              defaultOpen
              textStyle="small"
              isLocked={isLocked}
              key={index}
            >
              <LabeledValue
                label={<LabelText>{t('l.application.view.status.label', 'Status')}</LabelText>}
                value={<StatusComponent status={detail?.status} isLocked={isLocked} />}
                showBorder
                isLoading={isLoading}
              />
            </CollapsibleContainer>
          )
        })}
      </StatusContainer>
    </Wrapper>
  )
}

export default Mobile
